import type { ReactNode } from "react";

/** A row of filters: a search field and selects, or status pills. `fields` lets the search grow to fill the row. */
export function FilterBar({ fields, children }: { fields?: boolean; children: ReactNode }) {
  return <div className="bw-area-filterbar" data-fields={fields || undefined}>{children}</div>;
}

export function SearchField({ label, value, onChange }: { label: string; value: string; onChange: (next: string) => void }) {
  return <input type="search" className="bw-area-search" aria-label={label} placeholder={label} value={value} onChange={(event) => onChange(event.target.value)} />;
}

export function FilterSelect({ label, value, onChange, options }: { label: string; value: string; onChange: (next: string) => void; options: Array<{ value: string; label: string }> }) {
  return <select className="bw-area-select" aria-label={label} value={value} onChange={(event) => onChange(event.target.value)}>
    {options.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
  </select>;
}

export function FilterPills<T extends string>({ label, value, onChange, options }: { label: string; value: T; onChange: (next: T) => void; options: Array<{ value: T; label: string; count: number }> }) {
  return <div className="bw-area-pills" role="group" aria-label={label}>
    {options.map((option) => <button type="button" key={option.value} aria-pressed={value === option.value} onClick={() => onChange(option.value)}>{option.label} <span>{option.count}</span></button>)}
  </div>;
}
